/* Mostarle: release orphaned theme scroll locks without affecting visible drawers/modals. */
(function () {
  'use strict';

  var lockClasses = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  ];

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      element.getClientRects().length > 0;
  }

  function hasActiveLockingUI() {
    var selectors = [
      'modal-dialog[open]',
      'pickup-availability-drawer[open]',
      'details-modal details[open]',
      '.menu-drawer-container > details[open]',
      'menu-drawer details[open]',
      'cart-drawer.active',
      'cart-drawer[open]',
      '[role="dialog"][open]',
      '[role="dialog"][aria-modal="true"]:not([hidden])',
      '.insta-story__modal[data-open="true"]'
    ];

    return selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), isVisible);
    });
  }

  function hasScrollLock() {
    if (!document.body) return false;
    return lockClasses.some(function (name) {
      return document.body.classList.contains(name) ||
        document.documentElement.classList.contains(name);
    }) ||
    document.body.style.overflow === 'hidden' ||
    document.documentElement.style.overflow === 'hidden';
  }

  function releaseOrphanedLock() {
    if (!document.body || !hasScrollLock() || hasActiveLockingUI()) return;

    lockClasses.forEach(function (name) {
      document.body.classList.remove(name);
      document.documentElement.classList.remove(name);
    });

    if (document.body.style.overflow === 'hidden') {
      document.body.style.removeProperty('overflow');
    }
    if (document.documentElement.style.overflow === 'hidden') {
      document.documentElement.style.removeProperty('overflow');
    }
  }

  function scheduleRelease(delay) {
    window.setTimeout(releaseOrphanedLock, delay || 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleRelease(150);
    scheduleRelease(700);

    var observer = new MutationObserver(function () {
      if (hasScrollLock()) scheduleRelease(250);
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  });

  window.addEventListener('pageshow', function () {
    scheduleRelease(150);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') scheduleRelease(100);
  });
})();